import Typography from "typography";
import fairyGateTheme from "typography-theme-fairy-gates";
// import CodePlugin from "typography-plugin-code";

// fairyGateTheme.plugins = [
//     new CodePlugin(),
// ]

fairyGateTheme.overrideThemeStyles = ({ rhythm }, options, styles) => ({
    'h1,h3': {
        marginTop: 0,
        marginBottom: '1rem',
    },
    'a': {
        color: 'black',
        textShadow: 'none',
        backgroundImage: 'none',
    }
});

const typography = new Typography(fairyGateTheme);

export default typography;


// WEBPACK FOOTER //
// ./src/utils/typography.js